<template>
    <frm-modal-button btn-class="button button--icon button--text">
        <span class="button__icon-group">
            <frm-icon class="form-help__icon" name="info" />
        </span>
        <template #modal-body>
            <div v-html="content" />
        </template>
    </frm-modal-button>
</template>

<script>

export default {
    props: {
        translation: {
            type: String,
            required: true,
        },
    },

    computed: {
        content() {
            return this.$t(this.translation);
        },
    },
};
</script>
